(function () {
    angular.module('active-facebook-audience.dir', [])
        .directive('activeFacebookAudience', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeFacebookAudience]);

    function activeFacebookAudience($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.parseTitle = function(desc) {
                    if(desc) {
                        const title = desc;
                        return title.name;
                    }

                    return desc;
                };

                $scope.defineTitle = function(title) {
                    if(title) {
                        if(title === '1') {
                            return 'Add to';
                        }
                        return 'Remove from';
                    }

                    return title;
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if (!$scope.displayList) {
                        $scope.displayList = true;
                        if(!$scope.isFbConnect) {
                            $scope.testConn();
                        }
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.cancel = function() {
                    $scope.displayList = false;
                };

                $scope.testConn = function () {
                    $scope.isLoading = true;
                    canvasService.getConnections()
                        .then(({data}) => {
                            $scope.isFbConnect = data.ValidConnection;
                            if($scope.isFbConnect) {
                                $scope.connectedUser = data.UserName || false;
                            }
                            $scope.isLoading = false;
                        })
                        .catch(() => {
                            $scope.isFbConnect = false;
                            $scope.isLoading = false;
                        });
                };

                $rootScope.$on('hideFacebookAudienceModal', function() {
                    $scope.displayList = false;
                });
            }],
            link: function (scope, elem, attr) {
                if($rootScope.aElement) {
                    // bullet proving multiple targets
                    if(document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-facebook-audience'),
                        modalTemplate = $templateCache.get('active_templates/actions/modal-active-facebook-audience');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.audience = JSON.parse($rootScope.aElement.audience);
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });

                }
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/actions/active-facebook-audience.js